import { useNavigate } from 'react-router-dom';

import useProtectAction from '@/hooks/useProtectAction';
import useStateHandler from '@/hooks/useStateHandler';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';
import UserProfileImage from '@/shared-components/cards/components/UserProfileImage';
import Text from '@/shared-components/text/components/Text';
import { hasRenderableRating } from '@/utils/activityContent';
import { resolveFollowState } from '@/utils/followState';

import './styles/ProfileNotRatedCard.css';

export default function ProfileNotRatedCard({ data, ratingUser }) {
  const privateActionHandler = useProtectAction({ typeOfProtection: "USER_ACCOUNT_REQUIRED" });
  const navigate = useNavigate();
  const { cacheHandler } = useStateHandler();
  const revealRatingEntry = {
    _id: data?._id ?? null,
    createdAt: data?.createdAt ?? null,
    rating_values: data?.rating_values ?? null,
    rating_creator: ratingUser ?? data?.rating_creator ?? null,
  };
  if (!hasRenderableRating(data)) {
    return null;
  }
  const isFollowing = resolveFollowState({ cacheHandler, userId: ratingUser?._id, imFollowing: ratingUser?.im_following });

  return (
    <>
      <div className="profile-not-rated-card__outter-container">
        <div
          className={`profile-not-rated-card__container ${isFollowing ? 'following' : ''}`}
          onClick={() =>
            navigate(`/artwork/${data.rating_artwork.slug}?rate=true`, {
              state: {
                from: true,
                artworkViewSource: {
                  type: 'community',
                  label: '',
                },
                revealRatingEntry,
              }
            })
          }
        >
          <div className="comunity-not-rated-card__user-section">
            <UserProfileImage
              image={ratingUser.user_image?.image_id}
              typeOfProfile={ratingUser.user_type}
              className="profile-not-rated-card__user-image"
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/user/${ratingUser.user_username}`);
              }}
            />

            <div className="comunity-not-rated-card__user-info">
              <Text
                className="profile-not-rated-card__small-text profile-not-rated-card__username font-size-small"
                paragraph
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/user/${ratingUser.user_username}`);
                }}>
                {ratingUser.user_username}
              </Text> 
              <Text
                className="profile-not-rated-card__small-text profile-not-rated-card__artwork-context"
                paragraph
              >
                on <span className="profile-not-rated-card__title">{data.rating_artwork.artwork_about.artwork_title}</span>
              </Text>
            </div>
          </div>

          <ContinueButton
            className="profile-not-rated-card__rate-button"
            // small
            onClick={(e) => {
              e.stopPropagation();
              privateActionHandler(() =>
                navigate(`/artwork/${data.rating_artwork.slug}?rate=true`, {
                  state: {
                    from: true,
                    artworkViewSource: {
                      type: 'community',
                      label: '',
                    },
                    revealRatingEntry,
                  }
                })
              );
            }}
          >
                          Rate
          </ContinueButton>

          <ArtworkImage 
            image={data.rating_artwork.artwork_media.artwork_main_picture.image_id}
            imageClassName="profile-not-rated-card__artwork-image"
            imageTemplateClassName="profile-not-rated-card__artwork-image"
            forceSmaller={300}
          />
        </div>
      </div>
    </>
  );
}
